"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormDefinition = void 0;

var _page = require("./page");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var PageDefinition = _flowRuntime["default"].tdz(function () {
  return _page.PageDefinition;
});

var FormDefinition = _flowRuntime["default"].type("FormDefinition", _flowRuntime["default"].exactObject(_flowRuntime["default"].property("formId", _flowRuntime["default"].string()), _flowRuntime["default"].property("name", _flowRuntime["default"].string()), _flowRuntime["default"].property("pages", _flowRuntime["default"].array(_flowRuntime["default"].ref(PageDefinition))), _flowRuntime["default"].property("success", _flowRuntime["default"].object(_flowRuntime["default"].property("text", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("url", _flowRuntime["default"].string(), true)), true), _flowRuntime["default"].property("submitBtnText", _flowRuntime["default"].string(), true)));

exports.FormDefinition = FormDefinition;